#import "../fragments/setting-fragment.graphql"

query GetSetting($settingName: String!) {
    setting(settingName: $settingName) {
        ...Setting
    }
}
